import {Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {AnswerText} from '../../../data/models/test/answer';
import {ANSWER_TEXT_VALIDATORS} from '../../../../constants/validators';
import {AnswerService} from '../../../services/api/answer.service';
import {FormBuilder, FormGroup} from '@angular/forms';

@Component({
  selector: 'app-answer-text-edit-form',
  templateUrl: './answer-text-edit-form.component.html',
  styleUrls: ['./answer-text-edit-form.component.css']
})
export class AnswerTextEditFormComponent implements OnInit {

  readonly ANSWER_TEXT_VALIDATORS = ANSWER_TEXT_VALIDATORS;

  @Input() readonly !: boolean;
  @Input() testId!: number;
  @Input() questionId!: number;
  @Input() answer!: AnswerText;

  @ViewChild('input') inputElement!: ElementRef;

  public form!: FormGroup;
  public editMode = false;

  constructor(
    private fb: FormBuilder,
    private answerService: AnswerService,
  ) {
  }

  ngOnInit(): void {
    this.form = this.fb.group({
      text: [this.answer.text, this.ANSWER_TEXT_VALIDATORS.TEXT],
    });
  }

  setEditMode(value: boolean): void {
    this.editMode = value;
    if (value) {
      setTimeout(() => {
        this.inputElement.nativeElement.focus();
      }, 0);
    }
  }

  onEdit(event: MouseEvent): void {
    event.preventDefault();
    this.setEditMode(true);
  }

  onSubmit(event: MouseEvent): void {
    event.preventDefault();
    if (this.form.valid) {
      const text = this.form.controls.text.value;
      if (this.answer.text === text) {
        this.setEditMode(false);
      } else {
        this.answerService.updateAnswerText(this.testId, this.questionId, {text})
          .then(answer => {
            this.answer = answer;
            this.setEditMode(false);
          });
      }
    }
  }

  onCancel(event: MouseEvent): void {
    event.preventDefault();
    this.form.controls.text.setValue(this.answer.text);
    this.setEditMode(false);
  }

}
